export default __webpack_public_path__ + "img/44e28bda20b8d3c2260c7c1ae7aab99f.svg";